$(document).ready(function(){
    AssetManager.assets = Widgets;
    AssetManager.init();

    // widget embedding
    $('.event-content, .qgiv-form, .landing-page-container, .event-landing-page-container')
        .on('change', '.embed-height, .embed-width', function(){
            var $container = $(this).closest('.widget-embed-settings'),
                $snippet = $container.find('.embed-code-snippet'),
                code = $.parseHTML($container.find('.embed-code-snippet').attr('data-code')),
                _width = $container.find('.embed-width').val(),
                _height = $container.find('.embed-height').val();

            $(code).css({
                'width' : _width + 'px',
                'height' : _height + 'px'
            });

            var _snippet = $(code).prop('outerHTML');

            // fix for ampersand encoding
            _snippet = _snippet.replace(/&amp;/g, '&');

            $snippet.val(_snippet);
        })
        .on('focus', '.embed-code-snippet', function(){
            $(this).select();
        });

    // toggle the embed settings when the user clicks the embed this widget button
    // in CMS the embed settings button lives in .cms-settings-container instead of .widget
    $('.widget, .cms-settings-container')
        .on('click', '.trigger-embed-settings', function(e){
            var $container = $(this).closest('.widget-embed-settings'),
                $widget;

            // if we're in CMS, the DOM structure is different so we adjust which element we're grabbing
            if ( $container.closest('.cms-settings-container').length ) {
                $widget = $container.closest('.cms-control').find('.widget');
            } else {
                $widget = $container.closest('.widget');
            }

            var width = $widget.width(),
                height = $widget.height() + 56; // height plus extra for colophon

            $container.find('.embed-width').val(width).trigger('change');
            $container.find('.embed-height').val(height).trigger('change');

            // add the toggle the active class to the absolutely positioned wrapping element
            $container.closest('.widget-embed-settings').toggleClass('embed-settings-active');

            // if you click out, remove the active class
            UI.bindClickOut($container, function($selector){
                if( $selector.closest('.widget-embed-settings').hasClass('embed-settings-active') ){
                    $selector.closest('.widget-embed-settings').removeClass('embed-settings-active');
                }
            });

            e.preventDefault();
        });
});